import { Component, Input, ContentChildren, Output, QueryList, EventEmitter, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { genId } from '../../../../core/services/genId';
import { SelectOptionDirective } from './option.directive';
import { Subscription } from 'rxjs';

@Component({
    selector: 'luna-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    standalone: false
})
export class SelectComponent {
    id: string;
    public _subscriptions: Subscription = new Subscription();

    @Input('lunaModel')
    model: any | any[];
    @Output('lunaModelChange')
    modelChange: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    placeholder: string;
    @Input()
    disabled: boolean = false;
    @Input()
    multiple: boolean = false;

    @ContentChildren(SelectOptionDirective)
    items: QueryList<SelectOptionDirective>;
    @ViewChild('selectElement', { static: true })
    public _element: ElementRef;

    constructor(
        public _renderer: Renderer2
    ) {
        this.id = Object.freeze(genId());
    }

    ngAfterViewInit() {
        if (this.items.length > 0)
            this._selectItems(this.items);

        this.items.changes.subscribe((result: QueryList<SelectOptionDirective>) => {
            this._selectItems(result);
        });

        this._subscriptions.add(this._renderer.listen(this._element.nativeElement, 'change', (event) => {
            if (this.items.length > 0) {
                var selectedItems = this.items.filter(x => x.elementRef.nativeElement.selected);
                this.model = selectedItems.map(x => x.lunaValue);

                if (!this.multiple)
                    this.model = selectedItems[0].lunaValue;
            } else
                this.model = this._element.nativeElement.value;

            this.modelChange.emit(this.model);
        }));
    }

    ngOnDestroy() {
        this._subscriptions.unsubscribe();
    }

    public _selectItems(result: QueryList<SelectOptionDirective>) {
        result.forEach(x => { x.elementRef.nativeElement.selected = false });
        if (this.model) {
            if (this.model instanceof Array) {
                this.model.forEach(x => {
                    let item = result.find(y => y.lunaValue === x);

                    if (item)
                        item.elementRef.nativeElement.selected = true;
                });
            }
            else {
                let item = result.find(x => x.lunaValue === this.model);

                if (item)
                    item.elementRef.nativeElement.selected = true;
            }
        }
        else
            this.model = result.first.lunaValue;
    }
}
